import React from 'react'
export const Error500 = () => <div style={{padding:24}}><h1>500</h1><p>Server Error</p></div>
